import React from "react";

const readFirstDefined = (source, keys) => {
  if (!source) {
    return null;
  }

  const key = keys.find((item) => source[item] !== undefined && source[item] !== null);

  return key ? source[key] : null;
};

const formatList = (value) => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map((item) =>
      typeof item === "string" ? item : item.name || item.title || item.keyword || item.message || JSON.stringify(item)
    );
  }

  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [JSON.stringify(value)];
};

const PreviewSection = ({ title, children }) => (
  <div className="automation-preview-section">
    <h6>{title}</h6>
    {children}
  </div>
);

const PreviewList = ({ emptyText, items }) => {
  if (!items.length) {
    return <p className="mb-0 text-muted">{emptyText}</p>;
  }

  return (
    <ul className="automation-preview-list">
      {items.map((item, index) => (
        <li key={`${item}-${index}`}>{item}</li>
      ))}
    </ul>
  );
};

const TemplatePreviewModal = ({ template }) => {
  const name = readFirstDefined(template, ["name"]);
  const description = readFirstDefined(template, ["description"]);
  const initialSms = readFirstDefined(template, [
    "default_message",
  ]);
  const replyKeywords = readFirstDefined(template, [
    "default_rules",
  ]);
  const automationActions = readFirstDefined(template, [
    "default_actions",
  ]);
  const reminderActions = readFirstDefined(template, [
    "follow_up_steps",
  ]);
  const notificationActions = readFirstDefined(template, [
    "notification_actions",
    "notificationActions",
    "notifications",
  ]);

  return (
    <div className="modal fade" id="automation-template-preview" tabIndex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Template Preview</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {template ? (
              <>
                <PreviewSection title="Template">
                  <h5 className="mb-2">{name || "Untitled Template"}</h5>
                  <p className="mb-0 text-muted">{description || "No description available."}</p>
                </PreviewSection>

                <PreviewSection title="Initial SMS">
                  <p className="mb-0">{initialSms || "No initial SMS available."}</p>
                </PreviewSection>

                <PreviewSection title="Reply Keywords">
                  <PreviewList emptyText="No reply keywords available." items={formatList(replyKeywords)} />
                </PreviewSection>

                <PreviewSection title="Automation Actions">
                  <PreviewList emptyText="No automation actions available." items={formatList(automationActions)} />
                </PreviewSection>

                <PreviewSection title="Reminder Actions">
                  <PreviewList emptyText="No reminder actions available." items={formatList(reminderActions)} />
                </PreviewSection>

                {notificationActions ? (
                  <PreviewSection title="Notification Actions">
                    <PreviewList emptyText="No notification actions available." items={formatList(notificationActions)} />
                  </PreviewSection>
                ) : null}
              </>
            ) : (
              <p className="mb-0 text-muted">No template selected.</p>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePreviewModal;

